import React, { Component } from 'react';
import FilterList from './FilterList';
import ShowAllToggle from './ShowAllToggle';
import CalciteInput from '../../../shared/CalciteInput';

class FilterListWrapper extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      showAllFilterListItems: false,
    }
    this.displayFilterListItems = 10;
  }

  componentDidMount() {

  }

  filterFunctionUpdated = (e) => {
    this.props.filterFunctionUpdated(e);
  }

  handleFilterSelection = (e) => {
    this.props.handleFilterSelection(e);
  }

  handleDisplayFilterListItems = () => {
    this.setState({showAllFilterListItems: !this.state.showAllFilterListItems});
  }

  displayShowAllToggle = () => {
    if(this.props.filter.subFilters.length >= this.displayFilterListItems) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    const showAll = this.props.showAllItems || this.state.showAllFilterListItems;

    return (
      <div className="filter-list-wrapper">
        <CalciteInput
          className={`filter-list-wrapper-input ${this.props.searchClass}`}
          id={`filterSearch-${this.props.dataIndex}`}
          placeholder={this.props.searchInputText}
          icon="magnifying-glass"
          scale="m"
          onInput={this.filterFunctionUpdated}
        />
        <FilterList
          isFilterHidden={this.props.isFilterHidden}
          filterName={this.props.filterName}
          filter={this.props.filter}
          activeFiltersMap={this.props.activeFiltersMap}
          handleFilterSelection={this.handleFilterSelection}
          showAllFilterListItems={showAll}
          displayFilterListItems={this.displayFilterListItems}
        />
        {!this.props.showAllItems && (
          <div className={`showAllToggle-wrapper ${this.state.showAllFilterListItems ? 'showAllToggle-wrapper--sticky' : 'showAllToggle-wrapper--static'}`}>
            {this.displayShowAllToggle() &&
            <ShowAllToggle
              isFilterHidden={this.props.isFilterHidden}
              handleDisplayFilterListItems={this.handleDisplayFilterListItems}
            />}
          </div>
        )}
      </div>
    );
  }
}

export default FilterListWrapper;
